import React, { Component } from "react";
import ArticleComments from "./ArticleComments"


class OpenForBusiness extends Component {


  render() {
    var spacerStyle = {
      marginTop: "100px",

    }
    var cardGalleryStyle = {
      padding:20,
      backgroundColor: "white"
    }

    var imgCenterStyle = {
    display: "block",
    margin:"0 auto",
    marginBottom: 15
    }

    var size13 = {
      fontSize: 13
    }
  
    var answerStyle = {
      fontSize:16
    }

    return (

      <div className="container Site-content" id="cardGalleryWrapper" style={spacerStyle}>
        <div id="cardGallery" style={cardGalleryStyle} className="rounded">

          <h1>Welcome to Nova Blitz HQ</h1>

          <p style={size13}>
            By: Psynight - February 27, 2018
          </p>

          <img src={"../ArticleImages/Open.jpg"} style={imgCenterStyle} className="img-fluid" id="open" alt="open" />
          <p style={answerStyle}>
            Welcome everyone to our new community site for the game Nova Blitz.  Nova Blitz is a CCG (soon to be TCG) that was Kickstarted back in 2015.
            It is available on Steam now and is in beta for android and IOS.
          </p>
          <p style={answerStyle}>
            I have been playing card games for over twenty years, I started with Magic the Gathering, played a lot of Netrunner by WotC, Star Wars TCG and the Star Trek TCG.
            More recently I had played Fantasy Flight Games reboot of Netrunner "Android: Netunner".  An excellent game, if you are a fan of physical card games do yourself the favor
            of checking that out.  Digitally I have played Hearthstone for years, I have really enjoyed Eternal, and honestly Plants vs Zombies: Heroes is pretty solid.
          </p>
          <p style={answerStyle}>
            I tell you all of that to let you know I have been around the block when it comes to card games and will hopefully be able to shed some light on our little world of Nova Blitz.
          </p>
          <p>
            What I love about Nova Blitz that separates it from all the other games in the field is the real time aspect.  The decision making during that brief period of the combat phase is excellent.
            Are they going to attack? If I block am I just wasting potential damage if they do not attack?  It is great.  I have been loving playing other players and seeing what decks they have
            come up with.  A special shout out to Meatus he always has interesting decks and his have been the inspiration of many of mine.  So if you come up against my "steal all your guys" deck you can blame Meatus.
          </p>
          <p style={answerStyle}>
            My inspiration for building this site are two sites in particular Hearthpwn and Eternalwarcry.  Both sites are great community sites and my favorite thing about them is the deck
            building and sharing aspect.  I love being able to hop on Hearthpwn find a couple interesting decks and taking them for a spin. That is my ultimate hope for this site.  A place where we can all share decks and explore the depths of Nova Blitz together.
          </p>
          <p style={answerStyle}>
            My main focus will be getting the deck builder launched during the month of March.  I will try to get new articles written and posted once a week.  If you are interested
            in writing articles for the site please reach out.  The contact email is in the footer of this site.
          </p>
          <p style={answerStyle}>
            If you have any features or article requests feel free to email or put them in the comments below.  I do not plan on having a forum section.  I have put links to the official reddit and discord in the footer so feel free to
            communicate with the community there. I follow and am active in both.
          </p>
          <p style={answerStyle}>
            The primary coverage for this site will be Nova Blitz the game.  As the Nova Token platform takes shapes I will be posting news and writing articles about it as it pertains to the game.
            As additional projects from other develops start to take shape I would be interested in highlighting those on this site as well once the games have taken shape.
          </p>
          <p style={answerStyle}>
            Thanks for reading and I look forward to building a great community together, and seeing you in game!
          </p>
        </div>
          <ArticleComments articleId={"2"} />
      </div>


    );
  }
}

export default OpenForBusiness;



// WEBPACK FOOTER //
// ./src/Articles/OpenForBusiness.js